import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-4-small', 'Number4Small', [["path",{"d":"M10 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M14 8v8","key":"svg-1"}]]);